import React from 'react';
import cls from 'classnames';
import styles from './CheckboxSquare.module.scss';

function CheckboxSquare({isChecked, className}) {
  return (
    <span className={cls(styles.checkboxSquare, {[styles.checked]: isChecked}, className)}/>
  );
}

export default CheckboxSquare;
